import { Types } from './types'

const initialState = {
    dataUserAdmin: {
        paging: {},
        rows: [],
    },
}
const homeReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_USER_ADMIN:
            return {
                ...newState,
                dataUserAdmin: action.payload
            }
        default:
            return { ...newState }
    }
}
export default homeReducer
